import type { CtaSectionProps as Props } from './types';
import { withChildren } from '@builder.io/react';
import RichText from '@/components/RichText';
import { cls } from '@/utils/cls';
import style from './CtaSection.module.scss';
function CtaSection({
  extendStyles,
  copy,
  children,
  color,
  variant = 'Stacked'
}: Props) {
  const variantClass = variant === 'Stacked' ? style.stacked : style.inline;
  const _className = cls(style.root, extendStyles);
  const _contentClassNames = cls(style.content, variantClass);
  return <section className={_className} style={{
    backgroundColor: color || '#FFF'
  }} data-sentry-component="CtaSection" data-sentry-source-file="CtaSection.tsx">
			<div className={_contentClassNames}>
				{copy && <RichText text={copy} className={style.text} />}
				{children}
			</div>
		</section>;
}
export default withChildren(CtaSection);